const regex = /^[A-Za-z0-9](((\.(?!\.))|[-\w])*[A-Za-z0-9])?@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]{2,6}$/;
const getMessage = (field) => `${field} 格式不正確`;
const validate = (value) => regex.test(value);

/** 自訂驗證 Email 格式 */
export default {
  getMessage,
  validate,
};
